var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sider-menu"},[_c('div',{staticClass:"sider-menu-category"},[_c('span',{on:{"click":_vm.routeToExamCenter}},[_vm._v("统考中心")])])])}
var staticRenderFns = []

export { render, staticRenderFns }